import React from 'react';
import PropTypes from 'prop-types';

export const withLink = (WrappedComponent) => {
  const HoC = React.memo(props => (
    <a
      className="placement-link"
      href={props.finalUrl}
      rel="noopener noreferrer"
      target="_blank"
    >
      <WrappedComponent {...props} />
    </a>
  ));

  HoC.propTypes = {
    finalUrl: PropTypes.string.isRequired,
  };

  return HoC;
};
